export function formatPhoneNumber(phoneNumberString: string) {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    var intlCode = match[1] ? '+1' : '+1'
    return [intlCode, ' ', match[2], '-', match[3], '-', match[4]].join('')
  }
  return null
}

export function formatMemberPhoneNumber(phoneNumberString: string) {
  // clean - remove all non-digit characters
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '')

  // Turkey number formats:
  // if starts with 0 (e.g., 05355555555)
  if (cleaned.startsWith('0')) {
    var withoutZero = cleaned.substring(1) // remove leading zero
    var match = withoutZero.match(/^(\d{3})(\d{3})(\d{2})(\d{2})$/) // 10 digits: 5XX XXX XX XX
    if (match) {
      return ['+90', ' ', match[1], ' ', match[2], ' ', match[3], ' ', match[4]].join('')
    }
  }
  // if starts with 90 (e.g., 905355555555 or +905355555555)
  else if (cleaned.startsWith('90')) {
    var match = cleaned.match(/^(90)(\d{3})(\d{3})(\d{2})(\d{2})$/) // 12 digits: 90 5XX XXX XX XX
    if (match) {
      return ['+', match[1], ' ', match[2], ' ', match[3], ' ', match[4], ' ', match[5]].join('')
    }
  }

  // if not Turkey format, use USA format (original formatPhoneNumber logic)
  var usaMatch = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
  if (usaMatch) {
    var intlCode = usaMatch[1] ? '+1' : '+1'
    return [intlCode, ' ', usaMatch[2], '-', usaMatch[3], '-', usaMatch[4]].join('')
  }

  return null
}